export default __webpack_public_path__ + "static/galentine-valentine-6d125adcc200023cc0effe7372d1b9b1.jpg";